<template>
  <div>
    <b-overlay :show="show" rounded="sm">
      <b-card no-body static="false" class="mb-0 mt-4">
        <!-- <h2 class="pl-1 pr-1 mt-4">Médias manager</h2> -->
        <b-row ref="row" class="p-2">
          <!-- Images manager -->
          <b-col v-for="(item, index) in gallery" :id="item.key" :key="item.key" cols="12" md="1" style="padding: 3px;"
            class="align-items-center justify-content-start gallery">
            <div style="background-color: #eee; display: block;" class="p-1">
              <a :href=item.image :data-lightbox=item.key :data-title=item.key>
                <b-img-lazy :src="item.image" blank-src="@/assets/images/loading1.gif" center style="width: 100%;"
                  :title="item.key" v-b-tooltip.hover.bottom="item.key"></b-img-lazy>
              </a>
              <span style="text-align: center; display: block; width: 100%;" class="pt-1">
                <p style="text-align: center; font-size: 8px;">{{ item.key }}</p>
                <b-button v-ripple.400="'rgba(255, 255, 255, 0.15)'" variant="danger" class="btn-icon" size="sm"
                  @click="deleteAttachment(item, index)">
                  <feather-icon icon="Trash2Icon" />
                </b-button>
              </span>
            </div>
          </b-col>
        </b-row>
      </b-card>
    </b-overlay>
  </div>
</template>

<script>
import {
  BOverlay,
  BCard,
  BCardText,
  BRow,
  BCol,
  BFormInput,
  BInputGroup,
  BInputGroupAppend,
  BFormFile,
  BButton,
  BTable,
  BLink,
  BImg,
  BImgLazy,
  BDropdown,
  BDropdownItem,
  BPagination,
  BFormGroup,
  BFormCheckbox,
  BFormCheckboxGroup,
  VBTooltip,
  ImagePlugin,
} from 'bootstrap-vue'
import Ripple from 'vue-ripple-directive'
import PouchDB from 'pouchdb'
import axios from 'axios'

import "jquery/dist/jquery.min.js"
import "lightbox2/dist/css/lightbox.min.css"
import "lightbox2/dist/js/lightbox.min.js"

export default {
  components: {
    BOverlay,
    BCard,
    BCardText,
    BRow,
    BCol,
    BFormInput,
    BInputGroup,
    BInputGroupAppend,
    BFormFile,
    BButton,
    BTable,
    BLink,
    BImg,
    BImgLazy,
    BDropdown,
    BDropdownItem,
    BPagination,
    BFormGroup,
    BFormCheckbox,
    BFormCheckboxGroup,
    VBTooltip,
    ImagePlugin,
  },
  directives: {
    'b-tooltip': VBTooltip,
    Ripple,
  },
  data() {
    return {
      file: [],
      localDB: new PouchDB(localStorage.getItem('database')),
      remoteDB: new PouchDB(localStorage.getItem('url') + '/' + localStorage.getItem('database')),
      setting: JSON.parse(localStorage.setting),
      commercial: JSON.parse(localStorage.commercial),
      gallery: [],
      show: true,
    }
  },
  computed: {

  },
  watch: {},
  mounted() {

  },
  created() {
    axios.defaults.withCredentials = true
    this.initializeArticles()
  },
  methods: {
    async submitForm() {
      this.show = true
      console.log('fichier', this.file);

      for (let i = 0; i < this.file.length; i++) {

        var fullfilename = this.file[i].name
        var type = this.file[i].type
        var id = ''
        var rev = ''
        console.log('type', type);

        var extension = fullfilename.substr(fullfilename.lastIndexOf('.') + 1);
        console.log('extension', extension);

        var ref = fullfilename.split('-')[0];
        ref = ref.substr(0, 20);
        console.log('ref', ref);

        var filename = fullfilename.replace('.' + extension, '')
        console.log('filename', filename);

        await this.remoteDB.find({ selector: { type: 'articles', codearticle: ref } }).then(result => {
          console.log('result', result);
          if (result.bookmark != 'nil') {
            id = result.docs[0]._id
            console.log('id', id);
            rev = result.docs[0]._rev
            console.log('rev', rev);
          } else {
            id = '';
            rev = '';
          }
        })

        if (id != '' || rev != '') {
          // Upload file
          await axios.put(localStorage.getItem('url') + '/' + localStorage.getItem('database') + '/' + id + '/' + fullfilename + '?rev=' + rev,
            this.file[i],
            {
              headers: {
                "Content-Type": type
              }
            })
            .then(response => {
              console.log('Axios response', response)
            }).catch(error => {
              console.log('Axios error', error)
            })
        }
      }

      this.file = []

      await this.remoteDB.sync(this.localDB)
      await this.initializeArticles()

      this.show = false

    },
    //Initialize Articles
    async initializeArticles() {
      //Récupération des articles
      const mySelector = {};
      mySelector.type = 'articles';

      if (this.setting.saison != '' && this.commercial.showallsaison != 'true') {
        mySelector.categorie = this.setting.saison;
      }

      if (this.setting.filtre_articles_par_commerciaux == true || this.setting.filtre_articles_par_commerciaux == 'true') {
        mySelector.commerciaux = { $elemMatch: { $eq: localStorage.getItem('user') } };
      }
      
      await this.localDB.find({ selector: mySelector }, this.setArticles)
    },
    // Set Articles
    setArticles(err, doc) {
      this.show = true
      if (err) {
        console.log('err', err)
      } else {
        console.log('docArticles', doc)
        this.gallery = []
        for (let i = 0; i < doc.docs.length; i++) {
          this.show = true
          if (doc.docs[i]._attachments) {
            let j = 0
            for (const [key, value] of Object.entries(doc.docs[i]._attachments)) {
              // console.log(`${key}: ${value}`);
              this.localDB.getAttachment(doc.docs[i]._id, Object.keys(doc.docs[i]._attachments)[j]).then((blobOrBuffer) => {
                this.gallery.push({
                  id: doc.docs[i]._id,
                  key: key,
                  codearticle: doc.docs[i].codearticle,
                  image: URL.createObjectURL(blobOrBuffer)
                })
              })
              j++
            }
          }
        }
        console.log("products", this.gallery)
        this.show = false
      }

    },
    // Delete Attachment
    deleteAttachment(item, index) {
      this.$bvModal
        .msgBoxConfirm('Êtes vous sûr de supprimer cette image', {
          title: 'Suppression',
          size: 'sm',
          okVariant: 'danger',
          okTitle: 'Oui',
          cancelTitle: 'Non',
          cancelVariant: 'outline-secondary',
          hideHeaderClose: false,
          centered: true,
        })
        .then(value => {
          console.log(value);
          if (value == true) {
            this.remoteDB.get(item.id).then(resultget => {
              console.log(resultget);
              this.remoteDB.removeAttachment(item.id, item.key, resultget._rev).then(resultremote => {
                console.log(resultremote);
                this.gallery.splice(index, 1)
                this.remoteDB.sync(this.localDB)
              }).catch(function (err) {
                console.log(err);
              });
            }).catch(function (err) {
              console.log(err);
            });
          }
        })
    },
  },
}
</script>

<style>
.custom-file-input:lang(en)~.custom-file-label::after {
  content: 'Parcourir';
}

.gallery:hover img {
  opacity: 0.6;
}

.gallery button {
  opacity: 0.5;
}

.gallery:hover button {
  opacity: 1;
}
</style>